import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import BaseFieldDetail from "./detail";
export default function BaseFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, className = _a.className;
    return (_jsx(BaseFieldDetail, { fieldName: fieldName, record: record, className: className, viewType: FieldViewType.DETAIL }));
}
